import SERVICES_API_V1 from 'api/services/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import {
  CAMPAIGNS_LOAD_DATA_FAILED,
  YANDEX_SUBSCRIPTION_CAMPAIGN_FETCH,
  YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA,
} from 'modules/Services/types'

function* loadYandexSubscriptionCampaign({
  payload: { accountId, networkType, campaignId },
}) {
  try {
    const { response, error } = yield call(
      SERVICES_API_V1.loadYandexSubscriptionCampaign,
      { accountId, networkType, campaignId },
    )

    if (error) {
      throw error
    }

    yield put({
      type: YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA,
      payload: {
        campaign: response.data,
        loading: false,
      },
    })
  } catch (error) {
    yield put({ type: CAMPAIGNS_LOAD_DATA_FAILED })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )

    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(
    YANDEX_SUBSCRIPTION_CAMPAIGN_FETCH,
    loadYandexSubscriptionCampaign,
  )
}
